

import dayjs from "dayjs";
import { FiPlus, FiTrash } from "react-icons/fi";
import { useParams } from "react-router";
import ReactToPrint from "react-to-print";
import React, { useContext, useRef, useState, useEffect } from "react";
import { FiPrinter } from "react-icons/fi";
import { IoCloudDownloadOutline } from "react-icons/io5";
import SelectUser from "../components/form/SelectUser";
import SelectQuote from "../components/form/SelectQuote";
import UserServices from "services/UserServices";
import useQuoteSubmit from "hooks/useQuoteSubmit";
import Error from "components/form/Error";

import {
  TableCell,
  TableHeader,
  Table,
  TableContainer,
  WindmillContext,
} from "@windmill/react-ui";
import { PDFDownloadLink } from "@react-pdf/renderer";
import {
  Button,
  Input,
  Textarea
} from "@windmill/react-ui";
import useAsync from "hooks/useAsync";
import Status from "components/table/Status";
import OrderServices from "services/OrderServices";
import Invoice from "components/invoice/Invoice";
import Loading from "components/preloader/Loading";
import logoDark from "assets/img/logo/sim_new.jpg";
import logoLight from "assets/img/logo/sim_new_white.jpg";
import PageTitle from "components/Typography/PageTitle";
import InvoiceForDownload from "components/invoice/InvoiceForDownload";
import SettingServices from "services/SettingServices";
import { useTranslation } from "react-i18next";
import useToggleDrawer from "hooks/useToggleDrawer";
import { SidebarContext } from "context/SidebarContext";
import MainDrawer from "components/drawer/MainDrawer";
import AddUserDrawer from "components/drawer/AddUserDrawer";
import QuoteServices from "services/QuoteServices";
import { setDate } from "date-fns";
import { notifySuccess } from "utils/toast";
import { notifyError } from "utils/toast";
import { useHistory } from 'react-router-dom';

const QuoteManagementUpdate = () => {

  const history = useHistory();

  const { t } = useTranslation();
  const { mode } = useContext(WindmillContext);
  const { id } = useParams();
  const printRef = useRef();
  const [data, setData] = useState(null);
  const [rows, setRows] = useState([]);
  const { loading } = useAsync(() => QuoteServices.getAdminQuoteById(id));
  const { data: globalSetting } = useAsync(SettingServices.getGlobalSetting);

  const currency = globalSetting?.default_currency || "$";

  const [quoteDate, setQuoteDate] = useState("");
  const [quotes, setQuotes] = useState("");
  const [expirationDate, setExpirationDate] = useState("");
  const [quoteDescription, setQuoteDescription] = useState("");
  const { title, subtitle, short_description, description, allId, serviceId, handleDeleteMany, handleUpdateMany } =
    useToggleDrawer();


  const { toggleDrawer, lang } = useContext(SidebarContext);

  const [status, setStatus] = useState("Draft");
  const [tax, setTax] = useState("");
  const [isCheck, setIsCheck] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [discount, setDiscount] = useState(0);
  const [adjustments, setAdjustments] = useState(0);
  const [taxRate, setTaxRate] = useState(0);

  const [show, setShow] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [selecttedUser, setSelecttedUser] = useState(null);
  const [selecttedQuote, setSelecttedQuote] = useState(null);
  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState(null);
  const [users, setUsers] = useState([]);
  const [errors, setErrors] = useState({});
  const [productRowErrors, setProductRowErrors] = useState([]);
  const [productRows, setProductRows] = useState([
    // Your existing rows or initial data
  ]); 
  
  const handleUpdateQuote = async () => {

    setProductRowErrors([]);
    setShow(true);
    const rowErrors = productRows.map((row) => validateProductRow(row));

    // Check if there are any validation errors
    if (rowErrors.some((errors) => Object.keys(errors).length > 0)) {
      // Update the error state for each row
      setProductRowErrors(rowErrors);
      // Stop further processing if there are errors

    }
    // const formData = new FormData();
    // formData.append('status', status);
    // formData.append('quoteDate', quoteDate);
    // formData.append('expirationDate', expirationDate);
    // formData.append('user', user);
    // formData.append('selecttedUser', selecttedUser);
    // formData.append('selecttedQuote', selecttedQuote);
    // formData.append('total', total);
    // formData.append('totalAmount', totalAmount);
    // formData.append('taxRate', taxRate);
    // formData.append('discount', discount);
    // formData.append('adjustments', adjustments);
    // formData.append('productRows', productRows);
    // productRows.forEach((row, index) => {
    //   formData.append(`productRows[${index}][title]`, row.title);
    //   formData.append(`productRows[${index}][quantity]`, row.quantity);
    //   formData.append(`productRows[${index}][unit]`, row.unit);
    //   formData.append(`productRows[${index}][price]`, row.price);
    //   formData.append(`productRows[${index}][amount]`, row.amount);
    // });
    // formData.append('quoteDescription', quoteDescription);

    const formData = {
      status:status,
      quoteDate:quoteDate,
      expirationDate:expirationDate,
      user:user,
      selecttedUser:selecttedUser,
      selecttedQuote:selecttedQuote,
      total:total,
      totalAmount:totalAmount,
      taxRate:taxRate,
      discount:discount,
      adjustments:adjustments,
      productRows: productRows,
      quoteDescription:quoteDescription,
    };
    // Iterate over FormData entries and log them
    // for (const entry of formData.entries()) {
    //   console.log("e",entry);
    // }

  //  console.log('formm',JSON.stringify(formData));




      if(user == null && selecttedUser == null && selecttedQuote == null){
        const errorMessage = 'Please select a user or add a new user or select a quote request.';
        notifyError(errorMessage);
      }
      else{
        try {
          setIsLoading(true);
      const response = await QuoteServices.updateAdminQuoteTotal(id,formData);


      setIsLoading(false);



      notifySuccess(response.message);

      // setExpirationDate("");
      // setQuoteDate("");
      // setUser(null);
      // setUserName(null);
      // setProductRows([]);
      // setTotal(0);
      // setTotalAmount(0);
      // setDiscount(0);
      // setAdjustments(0);
      // setTaxRate(0);
      // setQuoteDescription('');
      // setShowInput(false);
      // setSelecttedQuote(null);
      // setSelecttedUser(null);
      // setUser(null);
      // setShow(false);
      setErrors({});
      history.push('/quotes-management');

      // setProductRowErrors([]);
    } catch (error) {

      if (error.response && error.response.status === 422) {
        // Handle validation errors
        const validationErrors = error.response.data.validation_errors;
        setErrors(validationErrors);
      }
      else {

        // console.error("Erreur lors d'ajout d'une référence", error);
        const errorMessage = "Erreur lors de l'enregistrement d'un devis : " + error;
        notifyError(errorMessage);
      }
    }
      }
 

  };




  const getAdminQuoteById = async () => {
    try {
      const res = await QuoteServices.getAdminQuoteById(id);
      // Mettez à jour le state avec les départements récupérés depuis l'API
      console.log(res.data, 'rrrrrrrrrrrrrrrrrrrrrrrrr');
      setStatus(res.data.status);
      setData(res.data);
      setShowInput(res.data.user_id != null ? 1 : 3);
      setExpirationDate(res.data.expirationDate);
      setQuoteDate(res.data.quoteDate);
      // setUser(res.data.user);
      // setUserName(res.data.user.name);
  
      setTotal(res.data.total);
      setTotalAmount(res.data.totalAmount);
      setDiscount(res.data.discount);
      setAdjustments(res.data.adjustments);
      setTaxRate(res.data.taxRate);
      setQuoteDescription(res.data.quoteDescription);
      // setShowInput(false);
      handleSelecttedQuote(res.data.quote_id);

      setSelecttedUser(res.data.user_id);
      
      setShow(false);
      setErrors({});
      setProductRowErrors([]);
    } catch (err) {
      console.log(err ? err?.response?.data?.message : err?.message);
    }
  }

  const getAdminQuoteRowsById = async () => {
    try {
      const res = await QuoteServices.getAdminQuoteRowsById(id);
      // Mettez à jour le state avec les départements récupérés depuis l'API
      setRows(res.data);
      console.log(res.data,'errre')
      const newRows = res.data.map(element => ({
        title: element.title,
        quantity: parseFloat(element.quantity) || 0, // Replace 'element.quantity' with the correct property name
        unit: element.unit || "",
        price: parseFloat(element.price) || 0,
        amount: parseFloat(element.total) || 0,
      }));
  
      setProductRows(newRows);
     
  console.log(newRows,"newRows");
    } catch (err) {
      console.log(err ? err?.response?.data?.message : err?.message);
    }
  }

  useEffect(() => {
    getAdminQuoteById();
    getAdminQuoteRowsById();
  }, [id]);



  const handleAdd = async () => {

    setShowInput(2);
    const user = localStorage.getItem('newUser')
    if (user) {
      // Convertir la chaîne JSON en objet JavaScript
      const userObject = JSON.parse(user);

      // Extraire le nom de l'utilisateur
      const userName = userObject.name;
      setUser(userObject.id);
      // Affecter le nom de l'utilisateur à la variable d'état 'user'
      setUserName(userName);
      setSelecttedQuote(null);

      setSelecttedUser(null);
    }
  };


  const handleSelecttedQuote = async (value) => {
    setSelecttedQuote(value);
    setUser(null);
    setSelecttedUser(null);
  }
  const handleSelecttedUser = async (value) => {
    setSelecttedQuote(null);
    setUser(null);
    setSelecttedUser(value);
  }

  const getUsersData = async () => {
    try {
      const res = await UserServices.getAllUser();
      // Mettez à jour le state avec les départements récupérés depuis l'API
      setUsers(res.data);
    } catch (err) {
      console.log(err ? err?.response?.data?.message : err?.message);
    }
  }

  const getQuetesRequestData = async () => {
    try {
      const res = await QuoteServices.getAll();
      // Mettez à jour le state avec les départements récupérés depuis l'API
      setQuotes(res.data);
    } catch (err) {
      console.log(err ? err?.response?.data?.message : err?.message);

    }
  }
  useEffect(() => {
    getUsersData();
    getQuetesRequestData();
  }, [])

  const handleCheckboxChange = (checkboxNumber) => {
    // Toggle the showInput state based on the checkbox selected
    setShowInput(checkboxNumber === showInput ? false : checkboxNumber);
  };



  const [totalAmount, setTotalAmount] = useState(0);
  const [total, setTotal] = useState(0);

  const handleAddRow = () => {
    const newRow = {
      title: "",
      quantity: 0,
      unit: "",
      price: 0,
      amount: 0,
    };
    setProductRows([...productRows, newRow]);

  };

  const handleDeleteRow = (index) => {
    const updatedRows = [...productRows];
    updatedRows.splice(index, 1);

    const discountPercentage = parseFloat(discount) || 0;
    const taxRatePercentage = parseFloat(taxRate) || 0;
    // Calculate the amount based on quantity and price

    let totalAmount = 0;
    let Total = 0;
    updatedRows.forEach(row => {
      totalAmount += row.amount;
    });

    const discountedAmount = totalAmount - (totalAmount * discountPercentage) / 100;
    const taxAmount = (discountedAmount * taxRatePercentage) / 100;
    Total = discountedAmount + taxAmount;
    setProductRows(updatedRows);
    setTotalAmount(totalAmount);
    setTotal(Total);

  };


  const handleStatusChange = async (newStatus) => {

    setStatus(newStatus);

  };


  const handleDiscountChange = (newDiscount) => {
    setDiscount(newDiscount);
    recalculateTotal(totalAmount, newDiscount, taxRate, adjustments);
  };

  const handleTaxRateChange = (newTaxRate) => {
    setTaxRate(newTaxRate);
    recalculateTotal(totalAmount, discount, newTaxRate, adjustments);
  };
  // const handleTotalChange = (total) => {
  //   setTotalAmount(total);
  //   recalculateTotal(total, discount, taxRate);
  // };

  const recalculateTotal = (subtotal, discountPercentage, taxRatePercentage, adjustment) => {
    const discountedAmount = subtotal - (subtotal * discountPercentage) / 100;
    const taxAmount = (discountedAmount * taxRatePercentage) / 100;
    const newTotal = discountedAmount + taxAmount;
    const tt = newTotal + parseFloat(adjustment);
    setTotal(tt.toFixed(2));
  };
  const handleAdjustmentsChange = (newAdjustments) => {

    setAdjustments(newAdjustments);
    recalculateTotal(totalAmount, discount, taxRate, newAdjustments);

  };
  const validateProductRow = (row) => {
    const errors = {};

    if (!row.title || row.title.trim() === "") {
      errors.title = "Description is required";
    }
    if (!row.unit || row.unit.trim() === "") {
      errors.unit = "Unit is required";
    }
    if (!row.quantity && row.quantity !== 0) {
      errors.quantity = "Quantity is required";
    } else if (isNaN(row.quantity) || row.quantity < 0) {
      errors.quantity = "Quantity must be a non-negative number";
    }
  
    if (!row.price && row.price !== 0) {
      errors.price = "Price is required";
    } else if (isNaN(row.price) || row.price < 0) {
      errors.price = "Price must be a non-negative number";
    }
  

    // Add other validations as needed

    return errors;
  };

  const handleInputChange = (index, key, value) => {
    const updatedRows = [...productRows];
    updatedRows[index][key] = value;




    // Ensure that quantity and price are valid numbers
    const quantity = parseFloat(updatedRows[index].quantity) || 0;
    const price = parseFloat(updatedRows[index].price) || 0;
    const discountPercentage = parseFloat(discount) || 0;
    const taxRatePercentage = parseFloat(taxRate) || 0;
    // Calculate the amount based on quantity and price
    updatedRows[index].amount = quantity * price;
    let totalAmount = 0;
    let Total = 0;
    updatedRows.forEach(row => {
      totalAmount += row.amount;
    });

    const discountedAmount = totalAmount - (totalAmount * discountPercentage) / 100;
    const taxAmount = (discountedAmount * taxRatePercentage) / 100;
    Total = discountedAmount + taxAmount;




    // setProductRows(updatedRows);
    setProductRows((prevRows) => [...prevRows.slice(0, index), updatedRows[index], ...prevRows.slice(index + 1)]);
  console.log(updatedRows,"updatedRows");

    setTotalAmount(totalAmount);
    setTotal(adjustments + Total);
 
  };

 

  useEffect(() => {
    // Recalculate totals whenever productRows, discount, taxRate, or adjustments change
    recalculateTotal(totalAmount, discount, taxRate, adjustments);
  }, [productRows, discount, taxRate, adjustments]);

  return (
    <>
      <PageTitle> {t("Update Quote")} </PageTitle>
      <MainDrawer>
        <AddUserDrawer id={serviceId} setIsCheck={setIsCheck} setIsLoading={setIsLoading} isLoading={isLoading} isCheck={isCheck} onDrawerClose={handleAdd} />

      </MainDrawer>
      <div
        ref={printRef}
        className="bg-white dark:bg-gray-800 mb-4 p-6 lg:p-8 rounded-xl shadow-sm overflow-hidden"
      >
        {!loading && (
          <div className="">
            <div className="flex lg:flex-row md:flex-row flex-col lg:items-center justify-between pb-4 border-b border-gray-50 dark:border-gray-700 dark:text-gray-300">
              <h1 className="font-bold font-serif text-xl uppercase">
                {t("Quote")}
                <p className="text-xs mt-1 text-gray-500">
                  {t("InvoiceStatus")}


                  <span className="pl-2 font-medium text-xs capitalize">
                    {" "}

                    <select
                      onChange={(e) => handleStatusChange(e.target.value)}
                      className={`px-2 py-1 rounded-full border-none`}
                    >
                      <option className="text-black bg-white border-none" value="Draft" selected={data?.status === "Draft"}>
                        {t("Draft")}
                      </option>
                      <option className="text-black bg-white border-none" value="New" selected={data?.status === "New"}>
                        {t("New")}
                      </option>
                      <option className="text-black bg-white border-none" value="Accepted" selected={data?.status === "Accepted"}>
                        {t("Accepted")}
                      </option>
                      <option className="text-black bg-white border-none" value="Rejected" selected={data?.status === "Rejected"}>
                        {t("Rejected")}
                      </option>
                      <option className="text-black bg-white border-none" value="Modified" selected={data?.status === "Modified"}>
                        {t("Modified")}
                      </option>
                      <option className="text-black bg-white border-none" value="Expired" selected={data?.status === "Expired"}>
                        {t("Expired")}
                      </option>
                    </select>


                  </span>
                </p>
              </h1>
              <div className="lg:text-right text-left">
                <h2 className="lg:flex lg:justify-end text-lg font-serif font-semibold mt-4 lg:mt-0 lg:ml-0 md:mt-0">
                  {mode === "dark" ? (
                    <img src={logoLight} alt="dashtar" width="110" />
                  ) : (
                    <img src={logoDark} alt="dashtar" width="110" />
                  )}
                </h2>

              </div>
            </div>
            <div className="flex lg:flex-row md:flex-row flex-col justify-between pt-4">
              <div className="mb-5 md:mb-0 lg:mb-0 flex flex-col">
                <span className="font-bold font-serif text-sm uppercase text-gray-600 dark:text-gray-500 block">
                  {t("Dates")}
                </span>
                <span className="text-sm text-gray-500 dark:text-gray-400 block">
                  {t('Date of the estimate')}

                  <Input
                    className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
                    name="quote_date"
                    type="date"
                    placeholder={t("Quote date")}
                    onChange={(e) => setQuoteDate(e.target.value)}
                    value={quoteDate}
                    required={true}
                  />

                  <span className="text-red-500 text-sm mt-1">{errors && errors.quoteDate && errors.quoteDate[0]}</span>
                </span>
                <span className="text-sm text-gray-500 dark:text-gray-400 block">
                  {t('Expiration date')}

                  <Input
                    className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
                    name="quote_date"
                    type="date"
                    placeholder={t("Expiration date")}
                    onChange={(e) => setExpirationDate(e.target.value)}
                    value={expirationDate}
                    required={true}
                  />

                  <span className="text-red-500 text-sm mt-1">{errors && errors.quoteDate && errors.expirationDate[0]}</span>
                </span>

              </div>
              <div className="mb-3 md:mb-0 lg:mb-0 flex flex-col">
                <span className="font-bold font-serif text-sm uppercase text-gray-600 dark:text-gray-500 block">
                  {t("Quote No")}
                </span>
                <span className="text-sm text-gray-500 dark:text-gray-400 block">
                  #{t('Quote')}-{data?.id}
                </span>
              </div>
              <div className="flex flex-col lg:text-right text-left">
                <span className="font-bold font-serif text-sm uppercase text-gray-600 dark:text-gray-500 block">
                  {t("InvoiceTo")}
                </span>
                <span className="text-sm text-gray-500 dark:text-gray-400 block">


                  <div className="pt-4">
                    <label>
                      <input
                        type="checkbox"
                        onChange={() => handleCheckboxChange(1)}
                        checked={showInput === 1}
                      />
                      {t('Existing user')}
                    </label>
                  </div>
                  {showInput == 1 && (
                    <div>
                      <label>
                        <SelectUser
                        t={t}

                          label="User"
                          name="user"
                          users={users}
                          selecttedUser={selecttedUser}
                          setSelecttedUser={(value) => handleSelecttedUser(value)}
                        />


                      </label>
                    </div>
                  )}
                  <div className="pt-4">

                    <label>
                      <input
                        type="checkbox"
                        onChange={toggleDrawer}
                        checked={showInput === 2}
                      />
                      {t('Add new user')}
                    </label>
                  </div>
                  {showInput == 2 &&(
                    <div>
                      <label>
                        <Input
                          className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
                          name="new_user"
                          type="text"
                          placeholder={"new user"}
                          // onBlur={(e) => handleProductSlug(e.target.value)}
                          // onChange={(e) => setUserName(e.target.value)}
                          value={userName}
                          readOnly
                        />


                      </label>
                    </div>
                  )}
                  <div className="pt-4">
                    <label>
                      <input
                        type="checkbox"
                        onChange={() => handleCheckboxChange(3)}
                        checked={showInput === 3}
                      />
                      {t('Quote request')}

                    </label>
                  </div>
                  {showInput == 3   && (
                    <div>
                      <label>
                        <SelectQuote
                          t={t}
                          label="Quote"
                          name="quote"
                          quotes={quotes}
                          selecttedQuote={selecttedQuote}
                          setSelecttedQuote={(value) => handleSelecttedQuote(value)}
                        />


                      </label>
                    </div>
                  )}
                  {show && user == null && selecttedUser == null && selecttedQuote == null && (
                    <span className="text-red-500 text-sm mt-1">{t('Please select a user or add a new user or select a quote request.')}</span>
                  )}
                  {/* {data?.user_info?.email}{" "}
                  <span className="ml-2">{data?.user_info?.contact}</span>
                  <br />
                  {data?.user_info?.address?.substring(0, 30)}
                  <br />
                  {data?.user_info?.city}, {data?.user_info?.country},{" "}
                  {data?.user_info?.zipCode} */}
                </span>
              </div>
            </div>
          </div>
        )}
        <div>
          {loading ? (
            <Loading loading={loading} />
          ) : (
            <>


              <TableContainer className="my-8">
                <Table>
                  <TableHeader>
                    <tr>
                      <TableCell>{t("Sr")}</TableCell>
                      <TableCell>{t("Description")}</TableCell>
                      <TableCell className="text-center">{t("Quantity")}</TableCell>
                      <TableCell className="text-center">{t("Unit ")}</TableCell>
                      <TableCell className="text-center">{t("Item Price HT")}</TableCell>
                      <TableCell className="text-right">{t("Amount HT")}</TableCell>
                      <TableCell className="text-right">{t("Actions")}</TableCell>
                    </tr>
                  </TableHeader>
                  <tbody>
                    {productRows.map((row, index) => (
                      <tr key={index}>
                        <TableCell className="text-gray-600 dark:text-gray-500">{index + 1}</TableCell>
                        <TableCell>
                          <Input
                            type="text"
                            placeholder="Description"
                            value={row.title}
                            onChange={(e) => handleInputChange(index, "title", e.target.value)}
                          />
                          <span className="text-red-500 text-sm mt-1">{productRowErrors[index] && productRowErrors[index].title}</span>

                        </TableCell>
                        <TableCell className="text-center">
                          <Input
                            type="number"
                            placeholder="Quantity"
                            value={row.quantity}
                            onChange={(e) => handleInputChange(index, "quantity", parseFloat(e.target.value))}
                          />
                          <span className="text-red-500 text-sm mt-1">{productRowErrors[index] && productRowErrors[index].quantity}</span>

                        </TableCell>
                        <TableCell className="text-center">
                          <Input
                            type="text"
                            placeholder="Unit"
                            value={row.unit}
                            onChange={(e) => handleInputChange(index, "unit", e.target.value)}
                          />
                          <span className="text-red-500 text-sm mt-1">{productRowErrors[index] && productRowErrors[index].unit}</span>

                        </TableCell>
                        <TableCell className="text-center">
                          <Input
                            type="number"
                            placeholder="Item Price"
                            value={row.price}
                            onChange={(e) => handleInputChange(index, "price", parseFloat(e.target.value))}
                          />
                          <span className="text-red-500 text-sm mt-1">{productRowErrors[index] && productRowErrors[index].price}</span>


                        </TableCell>
                        <TableCell className="text-right text-gray-600 dark:text-gray-500">{row.amount}</TableCell>
                        <TableCell className="text-right">
                          <Button onClick={() => handleDeleteRow(index)} className="mx-2">
                            <span className="text-xs">{t("Delete")}</span>
                            <FiTrash />
                          </Button>
                        </TableCell>

                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="mt-4">
                  <Button
                    onClick={handleAddRow}
                    className="flex items-center text-sm leading-5 transition-colors duration-150 font-medium focus:outline-none px-5 py-2 rounded-md text-white bg-orange-500 border border-transparent active:bg-orange-600 hover:bg-orange-600 focus:ring focus:ring-purple-300 w-auto"
                  >
                    <span className="mr-2">{t("Add Row")}</span>
                    <FiPlus />
                  </Button>
                </div>
                <span className="text-red-500 text-sm mt-1">{errors && errors.productRows && errors.productRows[0] && (
                  <>{t('The description rows is required.')}</>
                )}</span>

              </TableContainer>

            </>

          )}
        </div>

        {!loading && (
          <div className="border rounded-xl border-gray-100 p-8 py-6 bg-gray-50 dark:bg-gray-900 dark:border-gray-800">
            <div className="flex lg:flex-row md:flex-row flex-col justify-between">
              <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                <span className="mb-1 font-bold font-serif text-sm uppercase text-gray-600 dark:text-gray-500 block">
                  {t("Total Ht")}
                </span>
                <span className="text-sm text-gray-500 dark:text-gray-400 font-semibold font-serif block">
                  <Input
                    type="number"
                    placeholder="Total"
                    value={totalAmount}
                    onChange
                    readOnly
                  />


                </span>
              </div>
              <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                <span className="mb-1 font-bold font-serif text-sm uppercase text-gray-600 dark:text-gray-500 block">
                  {t("InvoiceDicount")} %
                </span>
                <span className="text-sm text-gray-500 dark:text-gray-400 font-semibold font-serif block">
                  <Input
                    type="number"
                    placeholder="Discount"
                    value={discount}
                    onChange={(e) => handleDiscountChange(parseFloat(e.target.value))}
                  />
                  <span className="text-red-500 text-sm mt-1">{errors && errors.discount && errors.discount[0]}</span>


                </span>
              </div>

              <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                <span className="mb-1 font-bold font-serif text-sm uppercase text-gray-600 dark:text-gray-500 block">
                  {t("Tax rate")}
                </span>
                <span className="text-sm text-gray-500 dark:text-gray-400 font-semibold font-serif block">
                  <select

                    onChange={(e) => handleTaxRateChange(parseFloat(e.target.value))}

                    className={`px-2 py-1 rounded-md border-none `}
                  >
                    <option className="text-black bg-white border-none" value="0" selected={data?.taxRate === "0.00"}>{t("0.00%")}</option>
                    <option className="text-black bg-white border-none" value="7" selected={data?.taxRate === "7.00"}>{t("7%")}</option>
                    <option className="text-black bg-white border-none" value="19" selected={data?.taxRate === "19.00"}>{t("19%")}</option>

                  </select>


                </span>
              </div>

              {/* <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                <span className="mb-1 font-bold font-serif text-sm uppercase text-gray-600 dark:text-gray-500 block">
                  {t("Adjustments HT")}
                </span>
                <span className="text-sm text-gray-500 dark:text-gray-400 font-semibold font-serif block">
                  <Input
                    type="number"
                    placeholder="Adjustments"
                    value={adjustments}
                    onChange={(e) => handleAdjustmentsChange(parseFloat(e.target.value))}
                  />
                  <span className="text-red-500 text-sm mt-1">{errors && errors.adjustments && errors.adjustments[0]}</span>


                </span>
              </div> */}
              <div className="flex flex-col sm:flex-wrap">
                <span className="mb-1 font-bold font-serif text-sm uppercase text-gray-600 dark:text-gray-500 block">
                  {t("InvoiceTotalAmount")} {parseFloat(taxRate).toFixed(2) != 0 ? t('TTC') : t('HT')}
                </span>
                <span className="text-xl font-serif font-bold text-red-500 dark:text-orange-500 block">

                  {parseFloat(total).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        )}
        <br />

        {!loading && (
          <div className="grid grid-cols-full gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
            <div className="col-span-8 sm:col-span-4">
              <Textarea
                className="border text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"

                name="description"
                placeholder={t("Description")}
                rows="4"
                value={quoteDescription}
                onChange={(e) => setQuoteDescription(e.target.value)}
                spellCheck="false"
              />
              <span className="text-red-500 text-sm mt-1">{errors && errors.quoteDescription && errors.quoteDescription[0]}</span>


            </div>
          </div>)}
      </div>
      {!loading && (
        <div className="mb-4 mt-3 flex justify-between">
          <div></div>
          <div>
            <button onClick={handleUpdateQuote} className="flex items-center text-sm leading-5 transition-colors duration-150 font-medium focus:outline-none px-5 py-2 rounded-md text-white bg-orange-500 border border-transparent active:bg-orange-600 hover:bg-orange-600 focus:ring focus:ring-purple-300 w-auto">
              {t("Save Quote")}

            </button>
          </div>
        </div>
      )}

    </>
  );
};

export default QuoteManagementUpdate;
